import type { ProductInformationViewModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const FindationQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    productId: ProductInformationViewModel['productId'];
    productName: ProductInformationViewModel['name'];
}>({
    isOpen: false,
    productId: 0,
    productName: {} as ProductInformationViewModel['name']
});

export default function useFindationQuickView() {
    return useMediatorState(FindationQuickViewAtom);
}
